module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Light.2a1edad950179e5291def49dd8f79bdc.woff";